var _style, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCabbage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4A38A;}\n\t.st1{fill:#B82555;}\n\t.st2{fill:none;stroke:#8F1711;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.44,96.73c-2.37-3.66-3.78-7.8-5.7-11.7c-3.78-7.77-9.69-14.58-17.22-18.84c-4.5-2.55-9.57-4.11-14.7-4.47 c-2.55-0.21-4.95,0.09-7.44,0.3c-2.1,0.21-4.32-0.63-6.18,0.54c-1.86,1.17-3.54,2.58-5.04,4.17c-8.82-2.37-18.93,0.9-24.66,8.04 c-0.66,0.81-1.26,1.65-2.07,2.28c-0.6,0.48-1.32,0.84-1.92,1.32c-1.68,1.38-2.25,3.93-1.38,5.91c-1.95-0.03-3.9,0.99-4.98,2.61 c-1.17,1.77-1.26,4.14-0.27,6c-1.62-0.93-3.63,1.08-3.45,2.94s1.65,3.27,3.03,4.53c-1.41,1.11-2.58,2.67-2.73,4.44 c-0.12,1.77,0.99,3.72,2.73,4.08c-2.19,1.77-1.71,5.37-0.15,7.71c1.59,2.34,4.41,5.52,5.79,7.98c-0.66-0.06-1.29-0.06-1.95,0 c-2.31,0.24-4.59,1.35-5.85,3.27c3.57,1.47,7.23,3.03,10.02,5.73c2.52,2.46,4.83,4.95,6.42,8.1c0.06,0.09,0.09,0.21,0.15,0.3 c2.61,4.92,7.8,8.58,13.35,9.93c2.28,0.54,4.59,0.78,6.9,0.75c0.03,0,0.03,0,0.06,0c5.25-0.06,10.56-1.35,15.54-3.15 c12.66-4.5,26.31-11.04,32.37-23.04c0.93-1.8,1.95-5.79,2.46-7.77c1.47-5.49,2.28-15.69,1.17-21.69 C152.57,97.72,154.7,97.69,156.44,96.73z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.16,136.51c-0.38-3.47,0.48-6.96,1.5-10.3c4.62-15.08,12.88-29.02,23.89-40.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.15,152.66c2.25-0.15,4.58-2.08,4.7-3.79c0.12-1.71-0.84-3.34-2.1-4.51c1.32,0.25,2.72,0.1,3.96-0.42 c0.41-0.17,0.83-0.41,0.99-0.82c0.16-0.42,0-0.88-0.18-1.29c-0.58-1.3-1.42-2.49-2.46-3.46c4.23,1.96,9.33,2.51,13.52,0.47 c0.56-0.27,1.12-0.62,1.39-1.18c0.56-1.18-0.49-2.46-1.45-3.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.17,66.74c-2.34,0.37-4.32,2.04-5.56,4.06c-1.23,2.02-1.81,4.37-2.24,6.7c-0.26,1.41-0.47,2.85-0.24,4.26 c0.17,1.05,0.58,2.04,0.81,3.08c0.62,2.81-0.15,5.89-2.03,8.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.48,145.89c-1.08,0.56-2.46,0.15-3.36-0.68c-0.9-0.82-1.42-1.97-1.9-3.09c-0.86-2-1.67-4.08-1.76-6.25 c-0.2-4.65,2.93-8.88,6.73-11.57c0.88-0.62,1.8-1.19,2.78-1.64c2.1-0.97,4.45-1.39,6.75-1.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.81,114.64c-0.42-0.66-0.31-1.52-0.11-2.27c1.65-6.51,7.97-11.09,14.58-12.3c3.36-0.61,6.81-0.5,10.2-0.95 c3.39-0.45,6.87-1.58,9.13-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.28,137.81c3.23-0.39,6.28-2.15,8.24-4.75c0.47-0.62,0.89-1.32,1-2.1c0.1-0.73-0.08-1.47-0.33-2.17 c-0.95-2.63-3.21-5-6-5.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.41,128.63c4.81-0.52,8.25-6.29,6.43-10.77c2.78-0.16,5.38-2.01,6.44-4.58c1.06-2.57,0.52-5.72-1.34-7.79 c3.62-2.66,3.51-8.99-0.2-11.52c1.42-1.76,1.36-4.55-0.13-6.25c-1.49-1.7-4.24-2.13-6.18-0.96c0.73-1.76,1.31-3.66,1.07-5.55 c-0.24-1.89-1.5-3.77-3.36-4.19c-0.67-0.15-1.46-0.15-1.91-0.68c-0.31-0.37-0.35-0.9-0.4-1.38c-0.19-1.82-0.88-3.69-2.32-4.81 c-1.44-1.13-3.75-1.25-5.01,0.08c-0.43-2.59-2.57-4.8-5.14-5.32c-2.57-0.52-5.4,0.7-6.8,2.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.42,107.08c0.95-0.24,1.9-0.49,2.85-0.73c0.52-0.13,1.3-0.08,1.31,0.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.06,93.71c-0.39-0.3-0.19-0.93,0.12-1.31c1.16-1.43,3.17-1.75,5-1.98c3.37-0.42,6.74-0.84,10.11-1.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.65,106.11c1.27-1.73,1.52-4,1.35-6.14c-0.49-5.93-3.91-11.51-3.35-17.44c0.16-1.67,0.73-3.44,2.12-4.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.15,95.09c-0.4,6.7,2.37,13.52,7.32,18.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.45,96.72c-3.09,1.71-7.46,0.45-9.15-2.65c-1.52,0.75-4.44,1.35-5.96,0.61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCabbage);
export default __webpack_public_path__ + "static/media/Red_cabbage.a4b983a9b720aa9523d443bebab3a93a.svg";
export { ForwardRef as ReactComponent };